import { Box, Stack, Skeleton, Avatar } from "@mui/material";

export default function TicketsChatSkeleton() {
  return (
    <Stack
      direction="row"
      sx={{
        height: "100vh",
        overflow: "hidden",
      }}
    >
      {/* Sidebar Skeleton */}
      <Box
        sx={{
          width: 280,
          minWidth: 280,
          borderRight: "1px solid #F0F0F0",
          display: "flex",
          flexDirection: "column",
          bgcolor: "#fff",
        }}
      >
        <Box sx={{ px: 2.5, pt: 2.5, pb: 1.5 }}>
          <Skeleton width={140} height={24} sx={{ borderRadius: 1 }} />
          <Skeleton width={120} height={16} sx={{ borderRadius: 1 }} />
        </Box>

        <Box sx={{ px: 2, pb: 2 }}>
          <Skeleton
            width="100%"
            height={36}
            sx={{ borderRadius: 2 }}
          />
        </Box>

        <Stack sx={{ px: 2, gap: 1 }}>
          {[1, 2, 3, 4, 5].map((i) => (
            <Stack
              key={i}
              direction="row"
              gap={1.5}
              alignItems="center"
              sx={{ py: 1 }}
            >
              <Skeleton variant="circular" width={40} height={40} />
              <Box sx={{ flex: 1 }}>
                <Skeleton
                  width="70%"
                  height={16}
                  sx={{ borderRadius: 1 }}
                />
                <Skeleton
                  width="50%"
                  height={14}
                  sx={{ borderRadius: 1, mt: 0.5 }}
                />
              </Box>
            </Stack>
          ))}
        </Stack>
      </Box>

      {/* Chat Panel Skeleton */}
      <Stack sx={{ flex: 1, bgcolor: "#FAFBFC" }}>
        {/* Header */}
        <Box
          sx={{
            px: 2.5,
            py: 1.5,
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            borderBottom: "1px solid #F0F0F0",
            bgcolor: "#fff",
          }}
        >
          <Skeleton variant="circular" width={38} height={38} />
          <Box sx={{ flex: 1 }}>
            <Skeleton
              width={160}
              height={18}
              sx={{ borderRadius: 1 }}
            />
            <Skeleton
              width={100}
              height={14}
              sx={{ borderRadius: 1, mt: 0.5 }}
            />
          </Box>
        </Box>

        {/* Messages */}
        <Stack sx={{ flex: 1, p: 3, gap: 2 }}>
          {[1, 2, 3].map((i) => (
            <Box
              key={i}
              sx={{
                display: "flex",
                gap: 1,
                alignItems: "flex-end",
                maxWidth: "60%",
                alignSelf: i === 2 ? "flex-end" : "flex-start",
              }}
            >
              {i !== 2 && (
                <Skeleton variant="circular" width={28} height={28} />
              )}
              <Skeleton
                width={i === 1 ? 280 : 200}
                height={i === 1 ? 70 : 50}
                sx={{ borderRadius: 3 }}
              />
            </Box>
          ))}
        </Stack>

        {/* Input */}
        <Box
          sx={{
            px: 2,
            py: 1.5,
            display: "flex",
            gap: 1,
            alignItems: "center",
            borderTop: "1px solid #F0F0F0",
            bgcolor: "#fff",
          }}
        >
          <Skeleton
            variant="circular"
            width={32}
            height={32}
          />
          <Skeleton
            variant="circular"
            width={32}
            height={32}
          />
          <Skeleton
            width="100%"
            height={38}
            sx={{ borderRadius: 3 }}
          />
          <Skeleton
            variant="circular"
            width={32}
            height={32}
          />
          <Skeleton
            variant="circular"
            width={38}
            height={38}
          />
        </Box>
      </Stack>
    </Stack>
  );
}
